import {api} from "./api";

export const chatApi = {
  joinCourseChatRoom: async (courseId) => {
    return api.chatSvcRequest("POST", `/chatRoomSignups?courseId=${courseId}`);
  },
  joinTestCallChatRoom: async (testCallId) => {
    return api.chatSvcRequest("POST", `/chatRoomSignups?testCallId=${testCallId}`);
  },
};
